// extracted by mini-css-extract-plugin
module.exports = {"downloadButton":"DownloadButton_downloadButton__Kj9mr","primary":"DownloadButton_primary__GEbJD","special":"DownloadButton_special__6IOQ4"};